import angular from 'angular';
import MenuItemService from './menu-item.service';
import SchoolCommonRoomService from './school-common-room.service';
import ClassRoomService from './class-room.service';
import EmployeeService from './employee.service';
import GroupService from './group.service';
import SchoolClassService from './school-class.service';
import SchedulePointService from './schedule-point.service';
import ActivityService from './activity.service';
import StudentService from './student.service';
import CategoryOfDepartureService from './category-of-departure.service';
import HappeningService from './happening.service';
import TalkService from './talk.service';
import RealizationService from './realization.service';
import AttendanceService from './attendance.service';
import SendNoteService from './send-note.service';
import UtilService from './util.service';
import AccessService from './access.service';
import SubstitutionService from './substitution.service';
import TagService from './tag.service';
import SummaryService from './summary.service';
import DataModificationLockService from './data-modification-lock.service';
import ChangesHistoryService from './changes-history.service';
import PinCodeService from './pin-code.service';
import ProximityCardService from './proximity-card.service';
import RegisterDataService from './register-data.service';

/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.services', [])
  .service('MenuItemService', MenuItemService)
  .service('SchoolCommonRoomService', SchoolCommonRoomService)
  .service('ClassRoomService', ClassRoomService)
  .service('EmployeeService', EmployeeService)
  .service('GroupService', GroupService)
  .service('SchoolClassService', SchoolClassService)
  .service('SchedulePointService', SchedulePointService)
  .service('ActivityService', ActivityService)
  .service('StudentService', StudentService)
  .service('CategoryOfDepartureService', CategoryOfDepartureService)
  .service('HappeningService', HappeningService)
  .service('TalkService', TalkService)
  .service('RealizationService', RealizationService)
  .service('AttendanceService', AttendanceService)
  .service('SendNoteService', SendNoteService)
  .service('UtilService', UtilService)
  .service('AccessService', AccessService)
  .service('SubstitutionService', SubstitutionService)
  .service('TagService', TagService)
  .service('SummaryService', SummaryService)
  .service('DataModificationLockService', DataModificationLockService)
  .service('ChangesHistoryService', ChangesHistoryService)
  .service('PinCodeService', PinCodeService)
  .service('ProximityCardService', ProximityCardService)
  .service('RegisterDataService', RegisterDataService)
  .name;
